(function(){
  'use strict';
  if (window.__BC_hoverColorFixBound) return;
  window.__BC_hoverColorFixBound = true;

  const CARD_SEL  = '.card';
  const IMG_SEL   = '.card-img img.changeImage';
  const COLOR_SEL = '.content-colors .color';
  const COLOR_OPTION_SEL = '.color-options .color-option';
  const NAME_LINK_SEL = '.card-info .content-name';
  const QUICK_BUY_SEL = '.quick-add-btn';
  const HOVER_ATTR = 'data-hover-image';
  const LOCK_ATTR  = 'data-hover-lock';

  // flags por card: suprime hover hasta mouseleave
  const suppressHover = new WeakMap();

  function getCard(el){ return el ? el.closest(CARD_SEL) : null; }
  function getImg(card){ return card ? card.querySelector(IMG_SEL) : null; }

  function setBase(img, url){
    if (!img) return;
    img.dataset.baseSrc = url || img.dataset.baseSrc || img.currentSrc || img.src;
  }

  function hideHoverOverlay(card){
    // Si tu tema usa overlay/segunda imagen por CSS, lo ocultamos mientras está bloqueado
    const overlay = card && card.querySelector('.product-hover-overlay, [data-hover-layer], .hover-image');
    if (overlay) {
      if (overlay.dataset.prevStyle === undefined) {
        overlay.dataset.prevStyle = overlay.getAttribute('style') || '';
      }
      overlay.style.opacity = '0';
      overlay.style.visibility = 'hidden';
      overlay.style.pointerEvents = 'none';
      
      // Quitar clase active si existe
      overlay.classList.remove('active');
    }
  }

  function showHoverOverlay(card){
    const overlay = card && card.querySelector('.product-hover-overlay, [data-hover-layer], .hover-image');
    if (overlay) {
      if (overlay.dataset.prevStyle !== undefined) {
        overlay.setAttribute('style', overlay.dataset.prevStyle);
        delete overlay.dataset.prevStyle;
      } else {
        overlay.style.opacity = '';
        overlay.style.visibility = '';
        overlay.style.pointerEvents = '';
      }
    }
  }

  function swapToHover(card){
    if (!card) return;
    const img = getImg(card);
    const hoverUrl = card.getAttribute(HOVER_ATTR);
    if (!img || !hoverUrl) return;
    setBase(img); // guarda base si no estaba
    img.src = hoverUrl;
    img.removeAttribute('srcset');
  }

  function restoreBase(card){
    const img = getImg(card);
    if (!img) return;
    const base = img.dataset.baseSrc;
    if (base && (img.currentSrc !== base && img.src !== base)) {
      img.src = base;
      img.removeAttribute('srcset');
    }
  }

  function restoreAll(){
    document.querySelectorAll(CARD_SEL).forEach((card)=>{
      restoreBase(card);
      showHoverOverlay(card);
    });
  }

  // ---------- Hover seguro (en todo el card excepto botones de color) ----------
  document.addEventListener('mouseover', (e)=>{
    const card = getCard(e.target);
    if (!card) return;

    // NO aplicar hover si estamos sobre un botón de color
    const isOnColor = e.target.closest(COLOR_SEL) || e.target.closest(COLOR_OPTION_SEL);
    if (isOnColor) return;

    // Si veníamos desde dentro del card, no hacer hover (evita re-disparos al moverte por hijos)
    const from = e.relatedTarget;
    if (from && card.contains(from)) return;

    // Si tenemos imagen de hover, aplicarla
    if (card.hasAttribute(HOVER_ATTR)) swapToHover(card);
  }, true);

  document.addEventListener('mouseout', (e)=>{
    const card = getCard(e.target);
    if (!card) return;

    // Si salimos del card completamente, restaurar imagen base (color seleccionado)
    const toEl = e.relatedTarget;
    if (!toEl || !card.contains(toEl)) {
      restoreBase(card);
      showHoverOverlay(card);
    }
  }, true);


  // salidas duras (cambio de pestaña/ventana)
  window.addEventListener('blur', restoreAll);
  document.addEventListener('visibilitychange', ()=>{ if (document.hidden) restoreAll(); });
  window.addEventListener('mouseout', (e)=>{ if (!e.relatedTarget) restoreAll(); });

  // ---------- Click en color (cambia imagen base y quita hover temporalmente) ----------
  document.addEventListener('click', function(e){
    const colorEl = e.target.closest(COLOR_SEL) || e.target.closest(COLOR_OPTION_SEL);
    if (!colorEl) return;

    // si ya estaba seleccionado, no hacemos nada
    if (colorEl.classList.contains('selected')) return;

    // marcar selección visual
    const group = colorEl.parentElement;
    if (group) {
      group.querySelectorAll('.color.selected, .color-option.selected').forEach(el=>el.classList.remove('selected'));
    }
    colorEl.classList.add('selected');

    const card = getCard(colorEl);
    const img  = getImg(card);
    const url  = colorEl.dataset.url;
    const colorImage = colorEl.dataset.colorImage;
    const colorHoverImage = colorEl.dataset.colorHoverImage;
    const selectedColor = colorEl.dataset.quickAddColor || colorEl.dataset.color || '';
    const selectedVariantId = colorEl.dataset.variantId || '';
    const productHandle = colorEl.dataset.productHandle || '';

    if (!card || !img) return;

    // PASO 1: Si estaba en hover, restaurar primero
    const currentBase = img.dataset.baseSrc;
    if (currentBase && img.src !== currentBase) {
      img.src = currentBase;
      img.removeAttribute('srcset');
    }

    // PASO 2: Cambiar imagen base al nuevo color
    const valid = colorImage && !/no[-_]?image/i.test(colorImage) && colorImage.trim() !== '';
    if (valid) {
      img.src = colorImage;
      img.removeAttribute('srcset');
      img.dataset.baseSrc = colorImage;
    }

    // PASO 3: Actualizar hover específico por color
    if (colorHoverImage && colorHoverImage.trim() !== '') {
      card.setAttribute(HOVER_ATTR, colorHoverImage);
    } else {
      card.removeAttribute(HOVER_ATTR);
    }

    // PASO 4: Actualizar enlaces
    if (url) {
      const nameLink = card.querySelector(NAME_LINK_SEL);
      const imgLink  = card.querySelector('.card-img');
      if (nameLink) nameLink.href = url;
      if (imgLink)  imgLink.href = url;
    }

    // PASO 4.1: Sincronizar quick buy con color/variante seleccionados
    const quickAddBtn = card.querySelector(QUICK_BUY_SEL);
    if (quickAddBtn) {
      if (selectedColor) quickAddBtn.dataset.selectedColor = selectedColor;
      if (selectedVariantId) quickAddBtn.dataset.selectedVariantId = selectedVariantId;
      if (productHandle) quickAddBtn.dataset.productHandle = productHandle;
    }

    // PASO 5: Forzar hover si el mouse está sobre el card
    // Esto es necesario porque el evento mouseover no se dispara si ya estamos dentro
    setTimeout(() => {
      // Verificar si el mouse está sobre el card pero NO sobre los colores
      const cardRect = card.getBoundingClientRect();
      const mouseX = window.lastMouseX || 0;
      const mouseY = window.lastMouseY || 0;
      
      const isMouseOverCard = mouseX >= cardRect.left && mouseX <= cardRect.right &&
                              mouseY >= cardRect.top && mouseY <= cardRect.bottom;
      
      if (isMouseOverCard && card.hasAttribute(HOVER_ATTR)) {
        swapToHover(card);
      }
    }, 50);
  });

  // Track mouse position globally
  document.addEventListener('mousemove', (e) => {
    window.lastMouseX = e.clientX;
    window.lastMouseY = e.clientY;
  }, { passive: true });

  // ---------- Inicialización base + precarga hover ----------
  // Antes esto precargaba con new Image() la imagen de hover de TODAS las tarjetas
  // al cargar la página. Eso se saltaba el loading="lazy" y descargaba ~100 imágenes
  // de golpe, incluidas las de tarjetas que nunca llegas a ver. Y en móvil, donde no
  // hay hover, no se usaba ni una sola.
  //
  // Ahora: en dispositivos con puntero se precarga solo cuando la tarjeta entra en
  // pantalla (así el hover sigue siendo instantáneo), y en táctil no se precarga nada.
  const puedeHacerHover = window.matchMedia('(hover: hover)').matches;
  const yaPrecargada = new WeakSet();

  function precargarHover(card){
    if (!card || !puedeHacerHover || yaPrecargada.has(card)) return;
    const hover = card.getAttribute(HOVER_ATTR);
    if (!hover) return;
    yaPrecargada.add(card);
    const pre = new Image();
    pre.src = hover;
  }

  document.addEventListener('DOMContentLoaded', ()=>{
    const cards = document.querySelectorAll(CARD_SEL);
    cards.forEach((card)=>{
      const img = getImg(card);
      if (img) setBase(img);
    });

    if (puedeHacerHover && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
          if (!entry.isIntersecting) return;
          precargarHover(entry.target);
          io.unobserve(entry.target);
        });
      }, { rootMargin: '200px' });
      cards.forEach((card)=> io.observe(card));
    }
  });

  // Red de seguridad para tarjetas añadidas después (sliders, filtros, quick add):
  // si el puntero llega a una que no se llegó a observar, se precarga en ese momento.
  document.addEventListener('pointerover', (e)=>{
    precargarHover(getCard(e.target));
  }, { passive: true });

  // ---------- Radios ----------
  (() => {
    const LABEL_SEL = 'label.spb-productoptionswatchwrapper';
    const RADIO_SEL = 'input.spb-productoptionbackground[type="radio"]';
    const wasChecked = new WeakMap();

    document.addEventListener('pointerdown', (e) => {
      const label = e.target.closest(LABEL_SEL);
      if (!label) return;
      const radio = label.querySelector(RADIO_SEL);
      if (radio) wasChecked.set(radio, radio.checked);
    }, true);

    document.addEventListener('click', (e) => {
      const label = e.target.closest(LABEL_SEL);
      if (!label) return;
      const radio = label.querySelector(RADIO_SEL);
      if (!radio) return;

      if (wasChecked.get(radio)) {
        e.preventDefault();
        e.stopPropagation();
        try { e.stopImmediatePropagation(); } catch(_) {}
        radio.checked = false;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        setTimeout(() => {
          if (radio.checked) {
            radio.checked = false;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, 0);
      }
    }, true);

    document.addEventListener('keydown', (e) => {
      const label = e.target.closest(LABEL_SEL);
      if (!label) return;
      const radio = label.querySelector(RADIO_SEL);
      if (!radio) return;
      if (e.key !== ' ' && e.key !== 'Enter') return;
      e.preventDefault();
      radio.checked = !radio.checked;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }, true);
  })();

  // ---------- Infinite options ----------
  // Usar MutationObserver para detectar cuando Infinite Options renderiza contenido
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfiniteOptionsObserver);
  } else {
    initInfiniteOptionsObserver();
  }

  function initInfiniteOptionsObserver() {
    const infiniteOptionsContainer = document.querySelector('#infiniteoptions-container');
    if (!infiniteOptionsContainer) return;

    // Verificar inmediatamente si ya tiene contenido
    if (infiniteOptionsContainer.children.length > 0) {
      infiniteOptionsContainer.style.display = 'block';
      return;
    }

    // Observer para detectar cuando se añaden elementos
    const observer = new MutationObserver((mutations) => {
      if (infiniteOptionsContainer.children.length > 0) {
        infiniteOptionsContainer.style.display = 'block';
        observer.disconnect(); // Ya no necesitamos observar más
      }
    });

    observer.observe(infiniteOptionsContainer, {
      childList: true,  // Detectar cuando se añaden/eliminan hijos
      subtree: false     // Solo el primer nivel
    });

    // Timeout de seguridad para desconectar el observer después de 5 segundos
    setTimeout(() => {
      observer.disconnect();
    }, 5000);
  }

})();